import { useState } from "react";
import { toast } from "react-toastify";
import api from "../services/api"; // ✅ centralized axios instance

const ElectionPortal = () => {
  const [candidate, setCandidate] = useState({
    name: "",
    party: "",
    position: "MLA",
    constituency: "",
    district: "",
    state: "",
    email: "",
    phone: "",
    manifesto: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setCandidate({ ...candidate, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post("/elections/register", candidate);

      toast.success("Registration submitted for verification!");

      setCandidate({
        name: "",
        party: "",
        position: "MLA",
        constituency: "",
        district: "",
        state: "",
        email: "",
        phone: "",
        manifesto: "",
      });
    } catch (err) {
      console.error("Error registering candidate", err);

      toast.error(
        err.response?.data?.message ||
          "Failed to register. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow">

        <h1 className="text-3xl font-bold text-blue-700 mb-6 text-center">
          🗳️ Register for Upcoming Election
        </h1>

        <p className="text-center text-sm text-gray-600 mb-6">
          "Desh banega jab neta bane zimmedar!" — Claim your space as a responsible candidate.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

            <input
              name="name"
              value={candidate.name}
              onChange={handleChange}
              placeholder="Full Name"
              className="w-full border px-4 py-2 rounded"
              required
            />

            <input
              name="party"
              value={candidate.party}
              onChange={handleChange}
              placeholder="Party Name"
              className="w-full border px-4 py-2 rounded"
              required
            />

            <input
              name="position"
              value={candidate.position}
              onChange={handleChange}
              placeholder="Position (MLA, MP, etc)"
              className="w-full border px-4 py-2 rounded"
              required
            />

            <input
              name="constituency"
              value={candidate.constituency}
              onChange={handleChange}
              placeholder="Constituency"
              className="w-full border px-4 py-2 rounded"
              required
            />

            <input
              name="district"
              value={candidate.district}
              onChange={handleChange}
              placeholder="District"
              className="w-full border px-4 py-2 rounded"
              required
            />

            <input
              name="state"
              value={candidate.state}
              onChange={handleChange}
              placeholder="State"
              className="w-full border px-4 py-2 rounded"
              required
            />

            <input
              name="email"
              value={candidate.email}
              onChange={handleChange}
              placeholder="Email"
              className="w-full border px-4 py-2 rounded"
              required
            />

            <input
              name="phone"
              value={candidate.phone}
              onChange={handleChange}
              placeholder="Phone"
              className="w-full border px-4 py-2 rounded"
              required
            />

          </div>

          <textarea
            name="manifesto"
            rows="4"
            value={candidate.manifesto}
            onChange={handleChange}
            placeholder="What are your goals if you win? (Your public manifesto)"
            className="w-full border px-4 py-2 rounded"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green-600 hover:bg-green-700 text-white py-3 font-semibold rounded"
          >
            {loading ? "Submitting..." : "Submit Registration"}
          </button>

        </form>

      </div>
    </div>
  );
};

export default ElectionPortal;